export default 'campaign-list'
